import { RowAdministratorCompanyDto, RowFormAdministratorCompanyDto, RowRoleDto } from "@/dtos";
import { AdministratorCompany, Company, Role } from "@/entities";

export const formatAdministratorCompanyFormTable = (companies: Company[]): RowFormAdministratorCompanyDto[] => {
    return companies.map((x) => {
        const row: RowFormAdministratorCompanyDto = {
            company_id: x.id,
            name: x.name,
            address: x.address,
            city: x.city?.name ?? ''
        }
        return row;
    });
}

export const formatAdministratorCompanySelected = (rows: RowFormAdministratorCompanyDto[], adminCompanies: AdministratorCompany[]) => {
    const rowsSelected = [] as RowFormAdministratorCompanyDto[];
    adminCompanies.map(x => {
        const row = rows.find(r => r.company_id == x.company_id);
        if (row) {
            rowsSelected.push(row);
        }
    });

    return rowsSelected;
}

export const formatAdministratorCompanyTable = (
    administratorCompanies: AdministratorCompany[],
    companies: Company[],
    roles: Role[],
    seacher?: string
): RowAdministratorCompanyDto[] => {
    const rows: RowAdministratorCompanyDto[] = [];

    for (const administratorCompany of administratorCompanies) {
        const row = rows.find((x) => x.company_id == administratorCompany.company_id);
        if (!row) {
            const roleDtos = roles.map((x) => {
                const adminRole = administratorCompany.administrator_company_roles.find((y) => y.role.id == x.id);
                const roleDto: RowRoleDto = {
                    role_id: x.id,
                    name: x.name,
                    hierarchy: (adminRole && adminRole.is_active) ? adminRole.hierarchy : undefined,
                    is_active: (adminRole && adminRole.is_active) ? true : false
                }
                return roleDto;
            });

            const company = companies.find((x) => x.id == administratorCompany.company_id && x.is_active);
            if (company) {
                rows.push({
                    id: administratorCompany.id,
                    company: company?.name ?? '',
                    company_id: administratorCompany.company_id,
                    is_active: administratorCompany.is_active,
                    items: roleDtos
                });
            }
        }
    }

    if (seacher) {
        return rows.filter(x => x.company.toLowerCase().includes(seacher.toLowerCase()));
    }

    return rows;
}